import { render, staticRenderFns } from "./NewWorker.vue?vue&type=template&id=96e5faa2&scoped=true"
import script from "./NewWorker.vue?vue&type=script&lang=js"
export * from "./NewWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e5faa2",
  null
  
)

export default component.exports